import { ALL_LOCATIONS } from '@/src/contexts/LocationsContext'
import { type ReactNode, createContext, useContext, useState } from 'react'

interface LoadPlanningCurrentLocationContextValue {
  locationId: number
  setLocationId: (locationId: number) => void
}

const LoadPlanningCurrentLocationContext = createContext<LoadPlanningCurrentLocationContextValue | undefined>(undefined)

export const useLoadPlanningCurrentLocation = (): LoadPlanningCurrentLocationContextValue => {
  const context = useContext(LoadPlanningCurrentLocationContext)
  if (!context) throw new Error('useLoadPlanningCurrentLocation must be used within LoadPlanningCurrentLocationProvider')
  return context
}

export const LoadPlanningCurrentLocationProvider = ({ children }: { children: ReactNode }) => {
  const [locationId, setLocationId] = useState<number>(ALL_LOCATIONS)

  return (
    <LoadPlanningCurrentLocationContext.Provider value={{ locationId, setLocationId }}>
      {children}
    </LoadPlanningCurrentLocationContext.Provider>
  )
}
